<div class="nav-bar">
  <a routerLink="/">
    <img
      alt="Logo"
      class="logo"
      src="../../../../assets/images/icon-AudConverter.svg"
    />
  </a>
  <div class="user-info">
    @if (user$ | async; as user) {
      @if (isAdminRoute && !environment.isSuperAdmin) {
        <button class="back-to-converter-button group" routerLink="/">
          <span
            class="material-symbols-rounded arrow group-hover:-translate-x-1"
          >
            keyboard_backspace
          </span>
          {{ "navbar.backToConverter" | translate }}
        </button>
      } @else if (!environment.isSuperAdmin) {
        @if (["Admin", "SuperAdmin"].includes(user.profile)) {
          <a class="admin-dashboard-link" routerLink="/admin">
            <span class="material-symbols-rounded">dashboard</span>
            <span class="link-text">{{ "navbar.adminArea" | translate }}</span>
          </a>
        }
      }
    }
    <div #langDropdownRef class="relative inline-block text-left">
      <button
        (click)="toggleLangDropdown()"
        class="flex items-center gap-2 px-3 py-2 border rounded text-sm border-gray-300 hover:bg-gray-100 w-[6rem]"
      >
        <img
          [src]="
            'https://flagcdn.com/w20/' +
            getCountryFromLang(currentLang) +
            '.png'
          "
          alt="flag"
          class="w-5 h-auto"
        />
        {{ currentLang.toUpperCase() }}
        <span class="material-symbols-rounded text-sm">expand_more</span>
      </button>
      @if (isLangDropdownOpen) {
        <div
          class="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded shadow z-50"
        >
          @for (lang of languages; track $index) {
            <button
              class="flex items-center gap-2 w-full px-6 py-2 text-sm hover:bg-gray-100"
              (click)="switchLang(lang.code)"
            >
              <img
                [src]="
                  'https://flagcdn.com/w20/' +
                  getCountryFromLang(lang.code) +
                  '.png'
                "
                alt="{{ lang.code }}"
                class="w-5 h-auto"
              />
              {{ lang.label | translate }}
            </button>
          }
        </div>
      }
    </div>
    @if (user$ | async; as user) {
      <div
        class="relative"
        (click)="toggleDropdownMenu($event)"
        #userDropdownRef
      >
        <div class="pfp">
          <span class="material-symbols-rounded account-icon">
            account_circle
          </span>
        </div>

        @if (isDropdownMenuOpen) {
          <ul class="user-dropdown">
            <li>
              <button class="user-dropdown-item" (click)="logoutButtonClick()">
                <span class="material-symbols-rounded">logout</span>
                <span>Logout</span>
              </button>
            </li>
          </ul>
        }
      </div>
    }
  </div>
</div>
